import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=91a641f6&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&id=91a641f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a641f6",
  null
  
)

export default component.exports